module.exports = __webpack_public_path__ + "img/ncz2.png";